// extracted by mini-css-extract-plugin
export default {"meatball":"user-edit-menu__meatball--dvDUk","tooltip":"user-edit-menu__tooltip--JuRcr"};